import { Trophy, CalendarDays, ArrowUpRight } from "lucide-react";
import { NEWS } from "@/lib/content";
import { Reveal, Eyebrow } from "./Reveal";

export const News = () => {
  const [n] = NEWS;
  return (
    <section id="haberler" data-testid="news-section" className="border-b border-white/10">
      <div className="mx-auto max-w-7xl px-5 py-24 md:px-8 md:py-28">
        <Reveal className="mb-12">
          <Eyebrow>Kulüpten Haberler</Eyebrow>
          <h2 className="font-display text-5xl uppercase leading-none text-white md:text-7xl">Son haber.</h2>
        </Reveal>
        <Reveal>
          <article data-testid={`news-item-${n.id}`} className="grid grid-cols-1 overflow-hidden border border-white/10 bg-surface lg:grid-cols-2">
            <div className="relative min-h-[420px] lg:min-h-[560px]">
              <img src={n.img} alt={n.alt} loading="lazy" className="absolute inset-0 h-full w-full object-cover object-[50%_45%]" />
              <div className="absolute left-6 top-6 flex h-16 w-16 -skew-x-12 items-center justify-center bg-brand">
                <Trophy className="h-8 w-8 skew-x-12 text-white" strokeWidth={1.75} />
              </div>
            </div>
            <div className="flex flex-col justify-center p-8 md:p-12">
              <div className="flex flex-wrap items-center gap-4 text-xs font-semibold uppercase tracking-[0.2em]">
                <span className="bg-brand px-3 py-1 text-white">{n.tag}</span>
                <span className="flex items-center gap-2 text-neutral-400" data-testid="news-date"><CalendarDays className="h-4 w-4" />{n.date}</span>
              </div>
              <h3 data-testid="news-title" className="mt-6 font-display text-4xl uppercase leading-[0.95] text-white md:text-6xl">{n.title}</h3>
              <p className="mt-5 inline-flex self-start border border-white/15 px-3 py-1.5 text-xs font-semibold uppercase tracking-[0.15em] text-neutral-300" data-testid="news-category">Kategori: {n.category}</p>
              <p className="mt-5 max-w-lg text-base leading-relaxed text-neutral-300 md:text-lg">{n.text}</p>
              <div className="mt-8 grid max-w-md grid-cols-2 gap-3">
                {n.gallery.map((g, i) => <img key={g.src} src={g.src} alt={g.alt} loading="lazy" data-testid={`news-photo-${i}`} className="aspect-[4/3] w-full border border-white/10 object-cover" />)}
              </div>
              <a href={n.link} target="_blank" rel="noopener noreferrer" data-testid="news-link" className="group mt-8 inline-flex items-center gap-2 self-start border-b border-brand pb-1 text-sm font-semibold uppercase tracking-wider text-white">
                {n.linkLabel} <ArrowUpRight className="h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
              </a>
            </div>
          </article>
        </Reveal>
      </div>
    </section>
  );
};
